var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4054 13.9718L17.7908 14.1681C18.2123 14.1811 18.5444 14.5343 18.5314 14.9558C18.5178 15.3779 18.1652 15.7095 17.7431 15.697L11.3583 15.5001L8.90725 22.6712C8.70926 23.2499 8.8761 23.8917 9.33031 24.3012C9.78505 24.7112 10.4403 24.8109 10.9963 24.5538C14.8591 22.7692 24.5489 18.2919 28.1637 16.622C28.6894 16.3785 29.0327 15.8595 29.0511 15.2807C29.069 14.7014 28.7583 14.1622 28.248 13.8873L11.6015 4.91245C11.0631 4.62212 10.4034 4.68077 9.92376 5.06142C9.44462 5.44263 9.23911 6.07246 9.40102 6.66331L11.4054 13.9718Z",
    fill: "#7F9D48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e648ad71662771bf71b3c250ac7c8912.svg";
export { ForwardRef as ReactComponent };